import styled from "styled-components";
import React from "react";

const CLOUDINARY_CLOUD_ID = window.cloudinaryCloudId;
export const CLOUDINARY_API_KEY = window.cloudinaryApiKey;
export const CLOUDINARY_API_SECRET = window.cloudinaryApiSecret;
export const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_ID}`;

export const MAX_SIZE_VIDEO = 100000000;
export const MAX_SIZE_IMAGE = 10000000;

export const FileUpload = styled.div`
  position: relative;
  font-weight: 400;
  background: #00000008;
  border-radius: 14px;
  padding: 5px 7px;
  margin: 11px 0px;
  display: inline-block;
  color: #1e22ff;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  label {
    cursor: pointer;
  }
`;

export const Input = styled.input`
  color: #1e22ff;
  font-weight: 400;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const StyledSpinner = styled.svg`
  animation: rotate 1s linear infinite;
  width: 1.2rem;
  height: 1.2rem;

  & .path {
    stroke: #02df79;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export const Spinner = () => (
  <StyledSpinner viewBox="0 0 50 50">
    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="2" />
  </StyledSpinner>
);
